import { Component, ElementRef, AfterViewInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ButtonModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent implements AfterViewInit {
  title = 'dscontrole-front';

  constructor(private el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    // Aguarda tema PrimeNG e estilos aplicados antes de exibir (reduz FOUC)
    requestAnimationFrame(() => {
      setTimeout(() => {
        this.el.nativeElement.classList.add('loaded');
      }, 200);
    });
  }
}
